import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react';
import { IconEye, IconEyeOff } from '@tabler/icons-react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { AuthService } from '../../services';
import { LoginBG, Logo } from '../../assets/images';

const Login = () => {

  const [showModal, setShowModal] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => setIsVisible(!isVisible);
  const { form, isLoading, onChange, onSubmit, onRecover } = useForm();

  return (
    <div id="login" className="flex flow-row h-screen">

      <Modal
        size="sm"
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => (
            <ModalForgotPassword
              onClose={onClose}
              onSubmit={async (email) => {
                const success = await onRecover(email);
                if (success) onClose();
              }}
            />
          )}
        </ModalContent>
      </Modal>

      <div className="login-bg w-1/2 hidden md:flex justify-center items-center">
        <img src={LoginBG} className="object-cover w-full h-full" alt="" />
      </div>
      <div className="w-1/2 flex flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm mb-4">
          <img className="mx-auto h-28 object-contain w-auto" src={Logo} alt={process.env.REACT_APP_NAME} />
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form className="space-y-6" onSubmit={onSubmit}>
            <div className="font-medium leading-6 flex flex-col gap-4">
              <Input
                label="Correo electrónico"
                labelPlacement="outside"
                placeholder=" "
                type="email"
                variant="bordered"
                classNames={{ label: 'text-md' }}
                radius="sm"
                value={form.email}
                onValueChange={v => onChange(v, 'email')}
              />

              <Input
                label="Contraseña"
                labelPlacement="outside"
                placeholder=" "
                variant="bordered"
                type={isVisible ? "text" : "password"}
                value={form.password}
                classNames={{ label: 'text-md' }}
                radius="sm"
                onValueChange={v => onChange(v, 'password')}
                endContent={
                  <button className="focus:outline-none" type="button" onClick={toggleVisibility}>
                    {isVisible ? (
                      <IconEyeOff className="w-6 h-6" />
                    ) : (
                      <IconEye className="w-6 h-6" />
                    )}
                  </button>
                }
              />
            </div>

            <div className="text-center flex flex-col items-center">
              <Button
                className="w-1/2 bg-green text-white text-md mt-12"
                type="submit"
                radius="sm"
                isLoading={isLoading}
                onPress={onSubmit}
              >
                <span className="font-semibold">Ingresar</span>
              </Button>

              <Link className="font-semibold text-secondary my-4 hover:underline cursor-pointer" to="/register">
                Registrarme
              </Link>
              {/* <span className="font-semibold my-4 hover:underline cursor-pointer" onClick={() => setShowModal(true)}>
                Cambio de contraseña
              </span> */}
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

const ModalForgotPassword = ({ onClose, onSubmit }) => {
  const [email, setEmail] = useState('');

  const submit = () => {
    if (!email) return toast.error('Debe indicar el correo');
    onSubmit(email);
  }

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Recuperación de contraseña</ModalHeader>
      <ModalBody>
        <p>Se le enviará un enlace a su correo electrónico para el cambio de contraseña</p>
        <div className="mt-4">
          <Input
            label="Correo"
            labelPlacement="outside"
            placeholder=" "
            classNames={{
              base: 'w-full',
              inputWrapper: 'border-1 h-10',
              label: 'text-md font-bold',
            }}
            value={email}
            onValueChange={setEmail}
          />
        </div>
      </ModalBody>
      <ModalFooter className="justify-evenly">
        <Button variant="light" onPress={onClose}>Cancelar</Button>
        <Button color="primary" onPress={submit}>Enviar</Button>
      </ModalFooter>
    </>
  )
}

const useForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '', remember: false });
  const [isLoading, setIsLoading] = useState(false);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    }

    if (!form.email)
      return onError('Debe ingresar el correo');

    if (!form.password)
      return onError('Debe ingresar la contraseña');

    return true;
  }

  const submit = async (event) => {
    if (event?.preventDefault) event.preventDefault();
    if (!isValidForm()) return;
    setIsLoading(true);

    try {
      const session = await AuthService.login(form);
      dispatch({ type: 'SET_USER', payload: session.user });
      navigate('/');

    } catch (error) {
      // toast.error(error || 'Ocurrió un error inesperado')
    }
    setIsLoading(false);
  }

  const recover = async (email) => {
    setIsLoading(true);

    try {
      await AuthService.recover({ email });
      toast.success('Se le ha enviado el link de recuperación a su correo');
      setIsLoading(false);
      return true;

    } catch (error) {
      toast.error(error || 'Ocurrió un error inesperado');
      setIsLoading(false);
      return false;
    }
  }

  return {
    form,
    isLoading,
    isValidForm,
    onChange,
    onRecover: recover,
    onSubmit: submit,
  };
}

export default Login;